import * as React from 'react';

import styles from './GreenTableCard.module.css';

interface GreenTableCardProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

export const GreenTableCard: React.FC<GreenTableCardProps> = ({ title, children, className }) => (
  <div className={`${styles.card}${className ? ` ${className}` : ''}`}>
    <div className={styles.header}>{title}</div>
    <div className={styles.body}>{children}</div>
  </div>
);
